// Module
var code = "<cjs-image-picker ref=\"imagePicker\"></cjs-image-picker>";
// Exports
module.exports = code;